import * as React from 'react';
import { SearchResult, SearchCategory } from '../../Model/core';
import { mapping } from './type';
import { className } from '../CourseMatrix/className';

interface Props {
    visible: boolean;
    result: SearchResult | null;
    more: (cat: SearchCategory) => void;
    element?: (element: HTMLDivElement) => void;
    query: string;
}

export function Result(props: Props) {
    return (
        <div
            className={className('search-result-container', { 'search-result-visible': props.visible })}
            ref={props.element}>

            {props.result && props.result.Groups
                .map(group => ({
                    cat: group.Category,
                    mapping: mapping[group.Category],
                    result: group.Result
                }))
                .filter(map => !!map.mapping)
                .map(map => React.createElement(map.mapping.component, {
                    key: map.cat,
                    result: map.result,
                    more: props.more
                }))}
        </div>
    );
}
